import { range, uniqueId } from 'lodash';
import moment from 'moment';

export const OTHER_NATIONAL_ACCOUNT_OPTION = 'otherNationalAccountOption';
export const NEW_CREDIT_CARD_OPTION = 'newCreditCardOption';
export const EXISTING_CREDIT_CARD_OPTION = 'existingCreditCardOption';
export const CONTINUE_WITHOUT_PAYMENT_METHOD_OPTION = 'withoutPaymentMethodOption';
export const NATIONAL_ACCOUNT_OPTION = 'nationalAccountOption';
export const PAY_BY_INVOICE = 'payByInvoice';

export const CREDIT_CARD_MANDATORY = 'M';
export const CREDIT_CARD_OPTIONAL = 'O';

export const MONTH_OPTIONS = [
  { label: '01 (January)', value: '01' },
  { label: '02 (February)', value: '02' },
  { label: '03 (March)', value: '03' },
  { label: '04 (April)', value: '04' },
  { label: '05 (May)', value: '05' },
  { label: '06 (June)', value: '06' },
  { label: '07 (July)', value: '07' },
  { label: '08 (August)', value: '08' },
  { label: '09 (September)', value: '09' },
  { label: '10 (October)', value: '10' },
  { label: '11 (November)', value: '11' },
  { label: '12 (December)', value: '12' },
];

export const YEAR_OPTIONS = range(51).map((offset) => {
  const year = moment().add(offset, 'years').format('YY');
  return {
    key: uniqueId(),
    label: year,
    value: year,
  };
});

interface ValidationResult {
  isValid: boolean;
  error: string | null;
}

export const isValidExpirationYearCard = (expirationYear: string) => {
  const result: ValidationResult = {
    isValid: true,
    error: null,
  };
  if (!expirationYear) {
    result.isValid = false;
    result.error = 'Required';
  }
  return result;
};

export const isValidExpirationMonthCard = (expirationMonth: string) => {
  const result: ValidationResult = {
    isValid: true,
    error: null,
  };
  if (!expirationMonth) {
    result.isValid = false;
    result.error = 'Required';
  }
  return result;
};

export const isValidLastFourDigitCard = (lastFourDigit: string) => {
  const result: ValidationResult = {
    isValid: true,
    error: null,
  };
  if (String(lastFourDigit).length !== 4) {
    result.isValid = false;
    result.error = 'Length should be 4';
  }
  return result;
};

export const isValidNameOnCard = (nameOnCard: string) => {
  const result: ValidationResult = {
    isValid: true,
    error: null,
  };
  if (String(nameOnCard).length < 5) {
    result.isValid = false;
    result.error = 'Min Length: 5';
  }
  return result;
};
export const isValidFirstDigitCard = (firstDigit: string) => {
  const result: ValidationResult = {
    isValid: true,
    error: null,
  };
  if (String(firstDigit).length !== 1 || Number.parseInt(firstDigit, 10) < 0 || Number.parseInt(firstDigit, 10) > 9) {
    result.isValid = false;
    result.error = 'Required';
  }
  return result;
};

export default {
  OTHER_NATIONAL_ACCOUNT_OPTION,
  NEW_CREDIT_CARD_OPTION,
  EXISTING_CREDIT_CARD_OPTION,
  CONTINUE_WITHOUT_PAYMENT_METHOD_OPTION,
  NATIONAL_ACCOUNT_OPTION,
  CREDIT_CARD_MANDATORY,
  CREDIT_CARD_OPTIONAL,
  MONTH_OPTIONS,
  YEAR_OPTIONS,
};
